import React,{Component} from 'react';
import ServiceCard from '../shared/ServiceCard';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';

class Services extends Component {
    componentDidMount(){
        document.body.scrollTo(0,0);
        return document.documentElement.scrollTo(0,0);
    };
    render(){
    return (
        <section className="services">
         <Helmet>
             <title>services</title>
         </Helmet>
         <div className="container">
         <div className="row">
             <div className="col-12 col-md-12 col-sm-12">
                  <div className="services_heading">
                     <h3 className="services_heading_content">More services we offer</h3>
                     <div className="services_divider" />
                 </div>
             </div>
         </div>
         <div className="services_list">
             <div className="row">
                 {
                    this.props.services.map((service,index) => (
                        <div className="col-12 col-sm-4 col-md-4" key={index}>
                        <ServiceCard data={service}/>
                        </div>
                    ))
                 }
             </div>
         </div>
         </div>
        </section>
    )
}};
const mapToProps = state => ({
    services:state.services.sub_services
});
export default connect(mapToProps,null)(Services);